module.exports = __webpack_public_path__ + "739e1581cf183c2a908f8c9096c73f47.svg";